import { Injectable } from '@angular/core';
import DriverInfoRequest from '../interfaces/RequestRecords/driverInfoRequest';
import authHeader from '../helpers/auth-header';
import { environment } from 'src/environments/environment';
import axios from 'axios';
import RecordRequest from '../interfaces/RequestRecords/RecordRequest';
import AuditDocument from '../interfaces/auditDocument';
import { DateTime } from 'luxon';
import DriverInfoRequestLicense from '../interfaces/RequestRecords/driverInfoRequestLicense';

@Injectable({
  providedIn: 'root'
})
export class RecordRequestService {

  constructor() { }


  submitRequests(requests: DriverInfoRequest[], source: string, authMethod: string): any {
    const config = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': authHeader()
        }
    };

    const url = `${environment.APP_API_URL}/api/v1/AccountHolderRecords/submitValidatedRequests?requestOrigin=${source}&authMethod=${authMethod}`;
    const data = {
        requests: requests,
        requestOrigin: source
    };
    return axios.post(url, requests, config)
        .then((response) => (response.data as any))
        .catch((error) => {
            console.error(error);
            return undefined;
        });
}

serverValidateRequests(requests: DriverInfoRequest[]) {
    const url = `${environment.APP_API_URL}/api/v1/AccountHolderRecords/validateRequests`;
    const config = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': authHeader()
        }
    };
    return axios.post(url, requests, config)
        .then((response) => (response.data as any))
        .catch((error) => {
            console.error(error);
            return 'CSInfoInfo';
        });
}

map(recordRequests: RecordRequest[], probationDocuments: AuditDocument[]): DriverInfoRequest[] {
    const driverInfoRequests: DriverInfoRequest[] = [];

    for (let index = 0; index < recordRequests.length; index++) {
        const r = recordRequests[index];
        const dobAsMMddyyyy = DateTime.fromFormat(r.dateOfBirth, 'MM/dd/yyyy').toFormat('MMddyyyy');
        const driverInfoRequest: DriverInfoRequest = {
            
            firstName: r.firstName,
            lastName: r.lastName,
            dateOfBirth: dobAsMMddyyyy,
            driverLicenseNumber: r.licenses[0].licenseNumber,
            driverConsent: r.disclosureAndAuthorizationCertified,
            internalRefId: r.internalReference,
            authCode: '',
            probationDocuments: probationDocuments,
            driverLicenses: []
        };
        for (let licenseIndex = 0; licenseIndex < r.licenses.length; licenseIndex++) {
            const l = r.licenses[licenseIndex];
            const driverInfoRequestLicense: DriverInfoRequestLicense = {
                lastName: l.lastName,
                licenseNumber: l.licenseNumber,
                state: l.licenseState,
            };
            driverInfoRequest.driverLicenses.push(driverInfoRequestLicense);
        }
        driverInfoRequests.push(driverInfoRequest);
    }
    return driverInfoRequests;
    }
}
